import React, { useRef } from "react";

import { Card } from "@bps/fluent-ui";
import { Country } from "@libs/enums/country.enum.ts";
import { UsersLabels } from "@modules/settings/screens/shared-components/SettingsLabels.ts";
import { AccContractForm } from "@modules/settings/screens/users/components/user-provider/AccContractForm.tsx";
import { ProviderAccContractContext } from "@modules/settings/screens/users/components/user-provider/context/ProviderAccContractContext.tsx";
import { ProviderAccContractHelper } from "@modules/settings/screens/users/components/user-provider/context/ProviderAccContractHelper.tsx";
import { User } from "@stores/core/models/User.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { Provider } from "@stores/practice/models/Provider.ts";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";
import { WhenCountry } from "@ui-components/WhenCountry.tsx";

interface AccContactsCardProps {
  user: User;
  provider: Provider | undefined;
}
export const AccContractsCard: React.FC<AccContactsCardProps> = ({
  user,
  provider
}) => {
  const root = useStores();
  const { core, practice } = root;

  const accContractHelper = useRef<ProviderAccContractHelper>(
    new ProviderAccContractHelper(root, user)
  );

  const fetchOrgUnit = async () => {
    const orgUnit = await practice.getOrgUnit(core.location.parentOrgUnit!.id);

    const practiceContracts = orgUnit?.nzAccContracts?.contracts ?? [];
    accContractHelper.current.setAvailableAccContracts(practiceContracts);
  };

  return (
    <WhenCountry is={Country.NewZealand}>
      <Card
        iconName="Handwriting"
        headingLevel="section-heading"
        heading={UsersLabels.accContracts}
        styles={{
          subComponentStyles: {
            tile: {
              content: {
                padding: 0
              }
            }
          }
        }}
      >
        <ProviderAccContractContext.Provider value={accContractHelper.current}>
          <DataFetcher fetch={fetchOrgUnit}>
            {() => (
              <AccContractForm
                user={user}
                contractTypes={provider?.contractTypes}
              />
            )}
          </DataFetcher>
        </ProviderAccContractContext.Provider>
      </Card>
    </WhenCountry>
  );
};
